/* Petciety storefront script: cart drawer, buy box, gallery, small motion. No libraries. */
(function () {
  'use strict';
  var PC = window.PC || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, currency) {
    var cur = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var v = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cur,
        minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return cur + ' ' + v.toFixed(2); }
  }
  PC.money = money;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
    return '\x3cimg src="' + esc(u) + '" alt="" loading="lazy" width="' + (w || 200) + '" height="' + (w || 200) + '">';
  }

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'pc-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  /* ---------- drawers ---------- */
  var lastFocus;
  function openDrawer(name) {
    var d = $('[data-pc-drawer="' + name + '"]'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = $('.pc-drawer__panel button, .pc-drawer__panel a', d); if (f) setTimeout(function () { f.focus(); }, 60);
    if (name === 'cart') renderCart();
  }
  function closeDrawers() {
    $$('.pc-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pc-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-pc-open')); return; }
    if (e.target.closest('[data-pc-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- cart ---------- */
  var cartCache = null;
  function getCart() { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; updateCount(c); return c; }); }
  function updateCount(c, bump) {
    $$('[data-pc-count]').forEach(function (el) {
      el.textContent = c.item_count; el.classList.toggle('has-items', c.item_count > 0);
      if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () { return getCart(); })
      .then(function (c) { updateCount(c, true); return c; });
  }
  PC.addItems = addItems;
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { cartCache = c; updateCount(c); return c; });
  }

  /* cart offers: complete the kit, add the vest, add the mat (only discounts that really exist) */
  function offerRow(o, cur) {
    return '<p class="pc-mono pc-cart__offh">' + esc(o.head) + '</p><div class="pc-upsell"><div class="pc-upsell__img">' + (o.img ? '\x3cimg src="' + esc(o.img) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div><div class="pc-line__t">' + esc(o.title) + '</div><div class="pc-line__v"><b style="color:var(--pc-cherry)">' + (o.from ? 'From ' : '') + money(o.price, cur) + '</b>' + (o.was > o.price ? ' <s>' + money(o.was, cur) + '</s>' : '') + (o.note ? '<br>' + esc(o.note) : '') + '</div></div>' +
      (o.add ? '<button type="button" class="pc-btn-sm pc-btn-sm--gold" data-pc-addq="' + o.add.id + ':' + o.add.quantity + '">Add</button>' : '<a class="pc-btn-sm pc-btn-sm--gold" href="' + esc(o.url) + '">' + esc(o.cta || 'Choose') + '</a>') + '</div>';
  }
  function offersHtml(c, cfg) {
    var K = cfg.catalog || {}, save = cfg.wrapSave || 0, out = [];
    function q(k) { var n = 0; c.items.forEach(function (it) { if (K[k] && it.product_id === K[k].pid) n += it.quantity; }); return n; }
    var vest = q('vest'), wrap = q('wrap'), mat = q('mat'), sleeve = q('sleeve'), cat = q('cat');
    if (vest && wrap < 2 && K.wrap && K.wrap.avail) {
      var need = 2 - wrap;
      out.push({ head: need === 2 ? 'Complete the Full Comfort Kit' : 'Finish the kit, add 1 more', title: need === 2 ? '2 Leg Wraps for elbows + knees' : '1 more Leg Wrap', note: money(K.wrap.price - save, c.currency) + ' each with your vest', price: (K.wrap.price - save) * need, was: K.wrap.price * need, img: K.wrap.img, add: { id: K.wrap.vid, quantity: need } });
    }
    if (wrap && !vest && K.vest && K.vest.avail) out.push({ head: 'Add the back + belly', title: 'Full-Body Vest', note: 'Your Leg Wraps drop to ' + money(K.wrap.price - save, c.currency) + ' each', price: K.vest.price, from: true, img: K.vest.img, url: K.vest.url + '?kit=2#buy', cta: 'Choose size' });
    if (sleeve && !vest && !wrap && K.wrap && K.wrap.avail) out.push({ head: 'Front legs too?', title: 'Leg Wrap', note: 'For stiff elbows and wrists', price: K.wrap.price, img: K.wrap.img, add: { id: K.wrap.vid, quantity: 1 } });
    if ((vest || wrap || sleeve || cat) && !mat && K.mat && K.mat.avail) out.push({ head: 'For whole-body naps', title: 'Red Light Mat', note: 'They stretch out, it covers everything', price: K.mat.price, img: K.mat.img, add: K.mat.multi ? null : { id: K.mat.vid, quantity: 1 }, url: K.mat.url });
    if (mat && !vest && !cat && K.vest && K.vest.avail) out.push({ head: 'Pairs well with', title: 'Full-Body Vest', note: 'Hands-free sessions for the back and belly', price: K.vest.price, from: true, img: K.vest.img, url: K.vest.url, cta: 'Choose size' });
    return out.slice(0, 2).map(function (o) { return offerRow(o, c.currency); }).join('');
  }
  function emptyPicks(c, cfg) {
    var K = cfg.catalog || {}, save = cfg.wrapSave || 0, out = [];
    if (K.vest && K.wrap) out.push({ head: 'Most popular', title: 'Full Comfort Kit', note: 'Vest + 2 Leg Wraps, back, belly and legs', price: K.vest.price + 2 * (K.wrap.price - save), was: K.vest.price + 2 * K.wrap.price, from: true, img: K.vest.img, url: K.vest.url + '?kit=0#buy', cta: 'Choose size' });
    if (K.wrap && K.wrap.avail) out.push({ head: 'One stiff joint', title: 'Leg Wrap', note: 'Elbows and knees', price: K.wrap.price, img: K.wrap.img, add: { id: K.wrap.vid, quantity: 1 } });
    if (K.mat && K.mat.avail) out.push({ head: 'Whole-body naps', title: 'Red Light Mat', note: 'For pets who stretch out', price: K.mat.price, img: K.mat.img, add: K.mat.multi ? null : { id: K.mat.vid, quantity: 1 }, url: K.mat.url });
    return out.length ? '<div class="pc-cart__picks">' + out.map(function (o) { return offerRow(o, c.currency || (window.Shopify && Shopify.currency && Shopify.currency.active)); }).join('') + '</div>' : '';
  }
  function renderCart() {
    var box = $('[data-pc-cart]'); if (!box) return;
    return getCart().then(function (c) { paintCart(c); });
  }
  function paintCart(c) {
    var box = $('[data-pc-cart]'); if (!box) return;
    var cfg = PC.cart || {};
    var items = $('[data-pc-cart-items]', box), foot = $('[data-pc-cart-foot]', box), ship = $('[data-pc-cart-ship]', box);
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var goal = Math.round((cfg.freeShip || 0) * rate);
    if (ship) {
      if (!goal) { if (cfg.shipText) { $('[data-pc-ship-text]', ship).innerHTML = '<b>' + esc(cfg.shipText) + '</b>' + (cfg.guarText ? '<br>' + esc(cfg.guarText) : ''); var bar = $('.pc-cart__bar', ship); if (bar) bar.style.display = 'none'; ship.classList.add('is-static'); } else ship.style.display = 'none'; }
      else {
        var left = goal - c.total_price, pct = Math.min(100, Math.round(c.total_price / goal * 100));
        $('[data-pc-ship-text]', ship).innerHTML = left > 0 ? 'You are <b>' + money(left, c.currency) + '</b> away from free shipping' : '<b>Free shipping unlocked.</b> Nice.';
        $('i', ship).style.width = pct + '%';
      }
    }
    if (!c.item_count) {
      items.innerHTML = '<div class="pc-cart__empty">' + (cfg.mascot ? '\x3cimg src="' + esc(cfg.mascot) + '" alt="" width="96" height="96">' : '') +
        '<p class="pc-card__t" style="margin:0">Your cart is empty</p><p class="pc-p" style="margin:6px 0 18px">Pick the wrap that fits their stiff spot.</p>' +
        '<a class="pc-btn pc-btn--red" href="' + esc(cfg.shopUrl || root + 'collections/all') + '">Shop now</a></div>' + emptyPicks(c, cfg);
      foot.style.display = 'none';
      return;
    }
    var html = '', saved = 0, K = cfg.catalog || {};
    function pq(k) { var n = 0; c.items.forEach(function (it) { if (K[k] && it.product_id === K[k].pid) n += it.quantity; }); return n; }
    var kv = pq('vest'), kw = pq('wrap'), km = pq('mat'), ks = pq('sleeve'), kc = pq('cat'), kit = null;
    if (kv && kw >= 2) kit = ks ? { name: 'Your Complete Comfort Kit', parts: ['vest', 'wrap', 'sleeve'] } : { name: 'Your Full Comfort Kit', parts: ['vest', 'wrap'] };
    else if (kv && kw === 1) kit = { name: 'Your Vest + Leg Wrap kit', parts: ['vest', 'wrap'] };
    else if (kc && km) kit = { name: 'Your Cat Vest + Mat bundle', parts: ['cat', 'mat'] };
    else if (ks && kw) kit = { name: 'Your Sleeve + Leg Wrap bundle', parts: ['sleeve', 'wrap'] };
    else if (km && ks) kit = { name: 'Your Mat + Hip Sleeve bundle', parts: ['mat', 'sleeve'] };
    else if (kw >= 2) kit = { name: 'Your 2 Leg Wraps bundle', parts: ['wrap'] };
    function inKit(it) { return kit && kit.parts.some(function (k) { return K[k] && K[k].pid === it.product_id; }); }
    var lineSave = function (it) { var cm = (cfg.compare && cfg.compare[it.variant_id]) ? cfg.compare[it.variant_id] * it.quantity : 0; return cm > it.final_line_price ? cm - it.final_line_price : it.original_line_price - it.final_line_price; };
    c.items.forEach(function (it) { saved += lineSave(it); });
    var cartLevel = 0; (c.cart_level_discount_applications || []).forEach(function (a) { cartLevel += a.total_allocated_amount || 0; });
    saved += cartLevel;
    if (kit) html += '<p class="pc-cart__kit"><b>' + esc(kit.name) + '</b>' + (saved > 0 ? '<span>You save ' + money(saved, c.currency) + '</span>' : '') + '</p>';
    c.items.forEach(function (it, i) {
      var was = it.original_line_price, now = it.final_line_price;
      var cmp = (cfg.compare && cfg.compare[it.variant_id]) ? cfg.compare[it.variant_id] * it.quantity : 0;
      html += '<div class="pc-line" data-line="' + (i + 1) + '">' +
        '<div class="pc-line__img">' + (it.image ? img(it.image, 144) : (cfg.mascot ? '\x3cimg src="' + esc(cfg.mascot) + '" alt="" style="width:60%;height:auto;object-fit:contain">' : '')) + '</div>' +
        '<div><a class="pc-line__t" href="' + esc(it.url) + '" style="text-decoration:none">' + esc(it.product_title) + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="pc-line__v">' + esc(it.variant_title) + '</div>' : '') + (inKit(it) ? '<div class="pc-line__kit">Part of your kit</div>' : '') +
        '<div class="pc-qty"><button type="button" aria-label="Decrease" data-pc-qty="-1">&minus;</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase" data-pc-qty="1">+</button></div></div>' +
        '<div class="pc-line__p">' + money(now, c.currency) + (cmp > now ? '<s>' + money(cmp, c.currency) + '</s>' : (was > now ? '<s>' + money(was, c.currency) + '</s>' : '')) + '</div></div>';
    });
    html += offersHtml(c, cfg);
    var titles = [];
    c.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && titles.indexOf(t) < 0) titles.push(t); }); });
    (c.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) < 0) titles.push(a.title); });
    if (titles.length) html = '<div class="pc-cart__win">' + titles.map(function (t) { return '<span>' + esc(t) + ' applied</span>'; }).join('') + '</div>' + html;
    items.innerHTML = html;
    foot.style.display = '';
    $('[data-pc-subtotal]', foot).textContent = money(c.total_price, c.currency);
    var sv = $('[data-pc-saved]', foot);
    var totalSaved = saved;
    if (sv) { sv.parentNode.style.display = totalSaved > 0 ? '' : 'none'; sv.textContent = '-' + money(totalSaved, c.currency); }
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-pc-qty]');
    if (q && cartCache) {
      var row = q.closest('[data-line]'); var line = +row.getAttribute('data-line');
      var it = cartCache.items[line - 1]; row.classList.add('is-busy');
      changeLine(line, Math.max(0, it.quantity + +q.getAttribute('data-pc-qty'))).then(paintCart);
      return;
    }
    var aq = e.target.closest('[data-pc-addq]');
    if (aq) { var pr = aq.getAttribute('data-pc-addq').split(':'); aq.classList.add('is-loading'); aq.setAttribute('aria-busy', 'true'); aq.textContent = 'Adding...'; addItems([{ id: +pr[0], quantity: +pr[1] || 1 }]).then(paintCart).catch(function (err) { aq.classList.remove('is-loading'); aq.textContent = 'Add'; toast(err.message); }); return; }
    var u = e.target.closest('[data-pc-upsell]');
    if (u) { u.classList.add('is-loading'); u.setAttribute('aria-busy', 'true'); if (u.tagName === 'BUTTON') u.textContent = 'Adding...'; addItems([{ id: +u.getAttribute('data-pc-upsell'), quantity: 1 }]).then(paintCart).catch(function (err) { toast(err.message); }); return; }
    var a = e.target.closest('[data-pc-add]');
    if (a) {
      e.preventDefault();
      var id = +a.getAttribute('data-pc-add'); if (!id) { location.href = a.getAttribute('href') || root; return; }
      a.classList.add('is-loading');
      addItems([{ id: id, quantity: 1 }]).then(function () { a.classList.remove('is-loading'); openDrawer('cart'); })
        .catch(function (err) { a.classList.remove('is-loading'); toast(err.message); });
    }
  });

  /* ---------- buy box ---------- */
  function initBuyBox(bb) {
    var dataEl = $('script[data-pc-product]', bb); if (!dataEl) return;
    var p = JSON.parse(dataEl.textContent);
    var state = { variant: null, qty: 1, opts: [] };
    var btn = $('[data-pc-atc]', bb), sticky = $('[data-pc-sticky-btn]');
    var start = p.variants.filter(function (v) { return v.id === p.selected; })[0] || p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    state.opts = start.options.slice();

    function findVariant() { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === state.opts[i]; }); })[0]; }
    function paint() {
      var v = findVariant(); state.variant = v;
      $$('[data-pc-chip]', bb).forEach(function (c) {
        var i = +c.getAttribute('data-opt'), val = c.getAttribute('data-pc-chip');
        c.classList.toggle('is-on', state.opts[i] === val); c.setAttribute('aria-pressed', state.opts[i] === val);
      });
      $$('[data-pc-offer]', bb).forEach(function (o) {
        var on = v && +o.getAttribute('data-pc-offer') === v.id;
        o.classList.toggle('is-on', on); var r = $('input', o); if (r) r.checked = on;
      });
      $$('[data-pc-optval]', bb).forEach(function (el) { el.textContent = state.opts[+el.getAttribute('data-pc-optval')] || ''; });
      $$('[data-pc-seg] button', bb).forEach(function (b) { b.classList.toggle('is-on', +b.value === state.qty); });
      if (!btn) return;
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      var price = money(v.price * state.qty);
      var label = v.available ? (btn.getAttribute('data-label') || 'Add to cart') + '  |  ' + price : 'Sold out';
      btn.disabled = !v.available; btn.textContent = label;
      if (sticky) { sticky.textContent = v.available ? (sticky.getAttribute('data-label') || 'Add to cart') + '  |  ' + price : 'Sold out'; }
      $$('[data-pc-price]', bb).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-pc-compare]', bb).forEach(function (el) { el.textContent = v.compare > v.price ? money(v.compare) : ''; });
      if (v.media && gal) gal.go(v.media, true);
      if (bb.hasAttribute('data-pc-pdp') && history.replaceState) {
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
      }
    }
    bb.addEventListener('click', function (e) {
      var c = e.target.closest('[data-pc-chip]');
      if (c) { state.opts[+c.getAttribute('data-opt')] = c.getAttribute('data-pc-chip'); paint(); return; }
      var o = e.target.closest('[data-pc-offer]');
      if (o) {
        var v = p.variants.filter(function (x) { return x.id === +o.getAttribute('data-pc-offer'); })[0];
        if (v) { state.opts = v.options.slice(); paint(); } return;
      }
      var s = e.target.closest('[data-pc-seg] button');
      if (s) { state.qty = +s.value; paint(); return; }
      var a = e.target.closest('[data-pc-atc]');
      if (a) { e.preventDefault(); add(a); }
    });
    function add(a) {
      if (!state.variant || !state.variant.available) return;
      a.classList.add('is-loading'); var old = a.textContent; a.textContent = 'Adding...';
      addItems([{ id: state.variant.id, quantity: state.qty }]).then(function () { a.classList.remove('is-loading'); a.textContent = old; openDrawer('cart'); })
        .catch(function (err) { a.classList.remove('is-loading'); a.textContent = old; toast(err.message); });
    }
    if (sticky) sticky.addEventListener('click', function (e) { e.preventDefault(); if (btn && !btn.disabled) add(sticky); });
    var gal = initGallery($('[data-pc-gallery]', bb));
    paint();
  }


  /* ---------- bundle (kit) buy box ---------- */
  function initKit(bb) {
    var dataEl = $('script[data-pc-kitdata]', bb); if (!dataEl) return;
    var d = JSON.parse(dataEl.textContent);
    var st = { card: d.selected || 0, pad: d.pad };
    var btn = $('[data-pc-atc]', bb), sticky = $('[data-pc-sticky-btn]');
    var padStep = $('[data-pc-padstep]', bb);
    function padV() { return d.pads.filter(function (v) { return v.id === st.pad; })[0] || d.pads[0]; }
    function calc() {
      var c = d.cards[st.card] || d.cards[0], pv = padV();
      var was = d.wrap.price * c.wraps + (pv ? pv.price * c.pads : 0);
      return { c: c, was: was, now: was - c.save, save: c.save, ok: d.wrap.available && (!c.pads || (pv && pv.available)) };
    }
    function paint() {
      var r = calc();
      $$('[data-pc-card]', bb).forEach(function (o) {
        var on = +o.getAttribute('data-pc-card') === st.card;
        o.classList.toggle('is-on', on); var i = $('input', o); if (i) i.checked = on;
      });
      $$('[data-pc-pad]', bb).forEach(function (b) { var on = +b.getAttribute('data-pc-pad') === st.pad; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
      var pv = padV(); $$('[data-pc-padname]', bb).forEach(function (e) { e.textContent = pv ? pv.title : ''; });
      if (padStep) padStep.hidden = !r.c.pads;
      $$('[data-pc-total]', bb).forEach(function (e) { e.textContent = money(r.now); });
      $$('[data-pc-was]', bb).forEach(function (e) { e.textContent = r.save > 0 ? money(r.was) : ''; });
      $$('[data-pc-save]', bb).forEach(function (e) { e.textContent = r.save > 0 ? 'You save ' + money(r.save) : ''; e.hidden = !(r.save > 0); });
      [btn, sticky].forEach(function (b) {
        if (!b) return;
        b.disabled = !r.ok;
        var l = $('[data-pc-atc-label]', b), p = $('[data-pc-atc-price]', b);
        if (l) l.textContent = r.ok ? (b.getAttribute('data-label') || (btn && btn.getAttribute('data-label')) || 'Add to cart') : 'Sold out';
        if (p) p.textContent = r.ok ? money(r.now) : '';
      });
    }
    function add(a) {
      var r = calc(); if (!r.ok) return;
      var items = []; if (r.c.wraps) items.push({ id: d.wrap.id, quantity: r.c.wraps });
      if (r.c.pads && st.pad) items.push({ id: st.pad, quantity: r.c.pads });
      a.classList.add('is-loading');
      addItems(items).then(function () { a.classList.remove('is-loading'); openDrawer('cart'); })
        .catch(function (err) { a.classList.remove('is-loading'); toast(err.message); });
    }
    bb.addEventListener('click', function (e) {
      var o = e.target.closest('[data-pc-card]');
      if (o) { e.preventDefault(); st.card = +o.getAttribute('data-pc-card'); paint(); return; }
      var p = e.target.closest('[data-pc-pad]');
      if (p) { st.pad = +p.getAttribute('data-pc-pad'); paint(); return; }
      var a = e.target.closest('[data-pc-atc]');
      if (a) { e.preventDefault(); add(a); }
    });
    bb.addEventListener('keydown', function (e) {
      var o = e.target.closest('[data-pc-card]');
      if (o && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); st.card = +o.getAttribute('data-pc-card'); paint(); }
    });
    if (sticky) sticky.addEventListener('click', function (e) { e.preventDefault(); if (btn && !btn.disabled) add(sticky); });
    initGallery($('[data-pc-gallery]', bb));
    paint();
  }

  /* ---------- vest buy box (size + kit) ---------- */
  function initVest(bb) {
    var dataEl = $('script[data-pc-vestdata]', bb); if (!dataEl) return;
    var d = JSON.parse(dataEl.textContent);
    var st = { size: d.size, card: d.selected || 0 };
    var q = new URLSearchParams(location.search);
    var qv = +q.get('variant'); if (qv && d.sizes.some(function (v) { return v.id === qv; })) st.size = qv;
    var qk = q.get('kit'); if (qk !== null && d.cards[+qk]) st.card = +qk;
    var btn = $('[data-pc-atc]', bb), sticky = $('[data-pc-sticky-btn]');
    var gal = initGallery($('[data-pc-gallery]', bb));
    function sizeV() { return d.sizes.filter(function (v) { return v.id === st.size; })[0] || d.sizes[0]; }
    function priceFor(card, sv) {
      var c = d.cards[card] || d.cards[0], wraps = d.wrap ? c.wraps : 0;
      var was = sv.price + (wraps ? d.wrap.price * wraps : 0), save = d.save * wraps;
      return { c: c, wraps: wraps, was: was, now: was - save, save: save, ok: sv.available && (!wraps || d.wrap.available) };
    }
    // compare-at = other stores' price for the same items (only when every item has one)
    function cmpFor(x, sv) {
      if (!(sv.compare > 0) || (x.wraps && !(d.wrap && d.wrap.compare > 0))) return 0;
      var c = sv.compare + (x.wraps ? d.wrap.compare * x.wraps : 0);
      return c > x.now ? c : 0;
    }
    function paint() {
      var sv = sizeV(), r = priceFor(st.card, sv);
      $$('[data-pc-size]', bb).forEach(function (b) { var on = +b.getAttribute('data-pc-size') === st.size; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
      var lb = $('[data-pc-size="' + st.size + '"]', bb);
      $$('[data-pc-sizename]', bb).forEach(function (e) { e.textContent = lb ? lb.getAttribute('data-label') : sv.title; });
      $$('[data-pc-card]', bb).forEach(function (o) { var on = +o.getAttribute('data-pc-card') === st.card; o.classList.toggle('is-on', on); var i = $('input', o); if (i) i.checked = on; });
      $$('[data-pc-inbox]', bb).forEach(function (e) { e.hidden = +e.getAttribute('data-pc-inbox') !== st.card; });
      var kc = $('[data-pc-card="' + st.card + '"]', bb), ks = $('[data-pc-kitslide] img', bb), kt = $('[data-pc-kitthumb] img', bb);
      if (kc && ks && kc.getAttribute('data-pc-kitimg') && st.kitCard !== st.card) {
        var first = st.kitCard === undefined; st.kitCard = st.card;
        if (!first) { ks.removeAttribute('srcset'); ks.src = kc.getAttribute('data-pc-kitimg'); if (kt) { kt.removeAttribute('srcset'); kt.src = kc.getAttribute('data-pc-kitthumbimg'); } if (gal) gal.go(0); }
      }
      var kTitle = kc && $('.pc-offer__t', kc) ? $('.pc-offer__t', kc).firstChild.textContent.trim() : '';
      $$('[data-pc-sticky-sub]').forEach(function (e) { e.textContent = d.sizes.length > 1 && lb ? 'Size: ' + lb.getAttribute('data-label') : (kTitle ? '' : e.textContent); });
      // sticky bar shows the picked bundle: its picture and its name, not the single product
      var kImg = kc && (kc.getAttribute('data-pc-kitthumbimg') || ($('img', kc) && $('img', kc).currentSrc) || ($('img', kc) && $('img', kc).src));
      $$('.pc-sticky__img').forEach(function (e) { if (kImg && e.getAttribute('src') !== kImg) { e.removeAttribute('srcset'); e.src = kImg; } });
      $$('.pc-sticky__t b').forEach(function (e) { if (!e.hasAttribute('data-name')) e.setAttribute('data-name', e.textContent); e.textContent = kTitle || e.getAttribute('data-name'); });
      d.cards.forEach(function (c, k) {
        var x = priceFor(k, sv);
        $$('[data-pc-cardprice="' + k + '"]', bb).forEach(function (e) { e.textContent = money(x.now); });
        var xc = cmpFor(x, sv);
        $$('[data-pc-cardwas="' + k + '"]', bb).forEach(function (e) { e.innerHTML = xc ? '<s>' + money(xc) + '</s>' : (x.save > 0 ? '<s>' + money(x.was) + '</s>' : ''); });
        var xs = xc ? xc - x.now : x.save;
        $$('[data-pc-cardsave="' + k + '"]', bb).forEach(function (e) { e.textContent = xs > 0 ? 'Save ' + money(xs) : ''; e.hidden = !(xs > 0); });
      });
      $$('[data-pc-total]', bb).forEach(function (e) { e.textContent = money(r.now); });
      var rc = cmpFor(r, sv);
      $$('[data-pc-was]', bb).forEach(function (e) { e.textContent = !rc && r.save > 0 ? money(r.was) : ''; });
      var rs = rc ? rc - r.now : r.save;
      $$('[data-pc-save]', bb).forEach(function (e) { e.textContent = rs > 0 ? 'You save ' + money(rs) : ''; e.hidden = !(rs > 0); });
      var lk = kc && kc.getAttribute('data-pc-link');
      $$('[data-pc-cmp]', bb).forEach(function (e) { var on = !lk && rc > 0; e.innerHTML = on ? '<s>' + money(rc) + '</s>' : ''; e.hidden = !on; });
      if (lk) {
        var lp = kc.getAttribute('data-pc-linkprice') || '', lw = kc.getAttribute('data-pc-linkwas') || '';
        var nP = parseFloat(lp.replace(/[^0-9.]/g, '')) || 0, nW = parseFloat(lw.replace(/[^0-9.]/g, '')) || 0;
        $$('[data-pc-total]', bb).forEach(function (e) { e.textContent = lp; });
        $$('[data-pc-was]', bb).forEach(function (e) { e.textContent = ''; });
        $$('[data-pc-cmp]', bb).forEach(function (e) { var on = nW > nP; e.innerHTML = on ? '<s>' + lw + '</s>' : ''; e.hidden = !on; });
        $$('[data-pc-save]', bb).forEach(function (e) { e.textContent = nW > nP ? 'You save $' + Math.round(nW - nP) : ''; e.hidden = !(nW > nP); });
      }
      [btn, sticky].forEach(function (b) {
        if (!b) return;
        var l = $('[data-pc-atc-label]', b), p = $('[data-pc-atc-price]', b);
        if (lk) { b.disabled = false; if (l) l.textContent = kc.getAttribute('data-pc-linklabel'); if (p) p.textContent = kc.getAttribute('data-pc-linkprice'); return; }
        b.disabled = !r.ok;
        if (l) l.textContent = r.ok ? (r.save > 0 ? 'Add the kit, save\u00a0$' + Math.round(rs / 100) : ((btn && btn.getAttribute('data-label')) || 'Add to cart')) : 'Sold out';
        if (p) p.textContent = r.ok ? money(r.now) : '';
      });
      if (bb.hasAttribute('data-pc-pdp') && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', st.size); history.replaceState(null, '', u.toString());
      }
    }
    function add(a) {
      var kl = $('[data-pc-card="' + st.card + '"]', bb); if (kl && kl.getAttribute('data-pc-link')) { location.href = kl.getAttribute('data-pc-link'); return; }
      var sv = sizeV(), r = priceFor(st.card, sv); if (!r.ok) return;
      var items = [{ id: sv.id, quantity: 1 }]; if (r.wraps) items.push({ id: d.wrap.id, quantity: r.wraps });
      a.classList.add('is-loading');
      addItems(items).then(function () { a.classList.remove('is-loading'); openDrawer('cart'); })
        .catch(function (err) { a.classList.remove('is-loading'); toast(err.message); });
    }
    bb.addEventListener('click', function (e) {
      var z = e.target.closest('[data-pc-size]');
      if (z) { st.size = +z.getAttribute('data-pc-size'); paint(); return; }
      var o = e.target.closest('[data-pc-card]');
      if (o) { e.preventDefault(); st.card = +o.getAttribute('data-pc-card'); paint(); return; }
      var a = e.target.closest('[data-pc-atc]');
      if (a) { e.preventDefault(); add(a); }
    });
    bb.addEventListener('keydown', function (e) {
      var o = e.target.closest('[data-pc-card]');
      if (o && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); st.card = +o.getAttribute('data-pc-card'); paint(); }
    });
    if (sticky) sticky.addEventListener('click', function (e) { e.preventDefault(); if (btn && !btn.disabled) add(sticky); });
    PC.pickSize = function (id) { st.size = id; paint(); };
    paint();
  }

  /* ---------- size finder ---------- */
  function initFinder(f) {
    var range = $('input[type=range]', f), out = $('[data-pc-finder-out]', f), val = $('[data-pc-finder-val]', f);
    var bands = JSON.parse($('script[data-pc-finderdata]', f).textContent);
    function upd() {
      var w = +range.value, b = bands.filter(function (x) { return w <= x.max; })[0] || bands[bands.length - 1];
      val.textContent = w + (w >= +range.max ? '+' : '') + ' lb';
      $$('[data-pc-band]', f).forEach(function (c, k) { c.classList.toggle('is-on', bands[k] === b); });
      if (out) out.textContent = b.label;
      f.setAttribute('data-pick', b.match);
    }
    range.addEventListener('input', upd);
    var go = $('[data-pc-finder-go]', f);
    if (go) go.addEventListener('click', function (e) {
      var bb = $('[data-pc-vest]'); if (!bb) return;
      e.preventDefault();
      var m = (f.getAttribute('data-pick') || '').toLowerCase();
      var btns = $$('[data-pc-size]', bb).filter(function (b) { return (b.getAttribute('data-label') || '').toLowerCase().indexOf(m) > -1; });
      if (btns[0]) btns[0].click();
      bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    upd();
  }

  /* ---------- autoplay loops (GIF-style video) ---------- */
  function initLoops() {
    var vids = $$('video[data-pc-loop]'); if (!vids.length) return;
    function arm(v) { var srcs = v.querySelectorAll('source[data-src]'); if (!srcs.length) return; srcs.forEach(function (so) { so.src = so.getAttribute('data-src'); so.removeAttribute('data-src'); }); v.preload = 'auto'; v.load(); }
    function go(v) { arm(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(go); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { var v = x.target; if (x.isIntersecting) go(v); else if (!v.paused) v.pause(); }); }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
    document.addEventListener('touchstart', function () { vids.forEach(function (v) { var r = v.getBoundingClientRect(); if (v.paused && r.top < innerHeight && r.bottom > 0 && r.left < innerWidth && r.right > 0) go(v); }); }, { once: true, passive: true });
  }

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (!g) return null;
    var main = $('.pc-gal__main', g), slides = $$('.pc-gal__slide', g), thumbs = $$('.pc-gal__thumb', g);
    if (!main || !slides.length) return null;
    function go(i, smooth) {
      if (typeof i === 'number' && i > 1000) { var m = slides.filter(function (s) { return +s.getAttribute('data-media') === i; })[0]; i = m ? slides.indexOf(m) : 0; }
      main.scrollTo({ left: main.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    var raf; main.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var pv = $('.pc-gal__arrow--prev', g), nx = $('.pc-gal__arrow--next', g);
    if (pv) pv.addEventListener('click', function () { var i = Math.round(main.scrollLeft / main.clientWidth); go(i > 0 ? i - 1 : slides.length - 1); });
    if (nx) nx.addEventListener('click', function () { var i = Math.round(main.scrollLeft / main.clientWidth); go(i < slides.length - 1 ? i + 1 : 0); });
    sync();
    return { go: go };
  }

  /* ---------- small motion ---------- */
  function initAnnc() {
    $$('.pc-annc').forEach(function (a) {
      var items = $$('.pc-annc__item', a); if (items.length < 2) return;
      var i = 0; setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 3800);
    });
  }
  function initHeader() {
    var h = $('.pc-hdr'); if (!h) return;
    var on = false;
    window.addEventListener('scroll', function () { var s = window.scrollY > 40; if (s !== on) { on = s; h.classList.toggle('is-stuck', s); } }, { passive: true });
  }
  function initTiles() {
    $$('[data-pc-tiles]').forEach(function (wrap) {
      var track = $('.pc-tiles', wrap), dots = $$('.pc-dots i', wrap); if (!track || !dots.length) return;
      track.addEventListener('scroll', function () {
        var tiles = $$('.pc-tile', track), mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
        tiles.forEach(function (t, k) { var d = Math.abs(t.offsetLeft + t.clientWidth / 2 - mid); if (d < bd) { bd = d; best = k; } });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === best); });
      }, { passive: true });
    });
  }
  function initReveal() { document.documentElement.classList.add('pc-rv');
    var els = $$('.pc-reveal, .pc-scrollband .pc-disp');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px 15% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function initSticky() {
    var bar = $('.pc-sticky'), anchor = $('[data-pc-sticky-anchor]'); if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var hero = $('[data-pc-hide-sticky]');
    var past = false, heroOn = !!hero;
    function upd() { bar.classList.toggle('is-on', past && !heroOn); }
    new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; upd(); }).observe(anchor);
    if (hero) new IntersectionObserver(function (en) { heroOn = en[0].isIntersecting; upd(); }).observe(hero);
  }
  function initDates() {
    var m = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var d = new Date();
    $$('.pc-month').forEach(function (e) { e.textContent = m[d.getMonth()]; });
    $$('.pc-year').forEach(function (e) { e.textContent = d.getFullYear(); });
    $$('[data-pc-arrive]').forEach(function (e) {
      var n = +e.getAttribute('data-pc-arrive') || 7, t = new Date(d);
      while (n > 0) { t.setDate(t.getDate() + 1); if (t.getDay() !== 0 && t.getDay() !== 6) n--; }
      e.textContent = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][t.getDay()] + ', ' + m[t.getMonth()].slice(0, 3) + ' ' + t.getDate();
    });

    function fmt(t) { return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][t.getDay()] + ', ' + m[t.getMonth()].slice(0, 3) + ' ' + t.getDate(); }
    function addBiz(n) { var t = new Date(d); while (n > 0) { t.setDate(t.getDate() + 1); if (t.getDay() !== 0 && t.getDay() !== 6) n--; } return t; }
    $$('[data-pc-arrive-range]').forEach(function (e) {
      var a = e.getAttribute('data-pc-arrive-range').split(',');
      e.textContent = fmt2(addBiz(+a[0] || 7)) + ' to ' + fmt2(addBiz(+a[1] || 12));
    });
    function fmt2(t) { return m[t.getMonth()].slice(0, 3) + ' ' + t.getDate(); }
    /* calm FOMO: real countdown to midnight, the arrival date moves a day after it */
    var cut = $$('[data-pc-cutoff]');
    function tick() {
      var now = new Date(), mid = new Date(now); mid.setHours(24, 0, 0, 0);
      var left = Math.max(0, mid - now), h = Math.floor(left / 36e5), mi = Math.floor(left % 36e5 / 6e4);
      cut.forEach(function (e) {
        var l = $('[data-pc-left]', e), b = $('[data-pc-by]', e);
        if (l) l.textContent = (h ? h + 'h ' : '') + mi + 'm';
        var f = $('[data-pc-from]', e);
        if (f) f.textContent = fmt2(addBiz(+f.getAttribute('data-pc-from') || 7));
        if (b) b.textContent = (f ? fmt2 : fmt)(addBiz(+e.getAttribute('data-pc-cutoff') || 12));
        e.hidden = false;
      });
    }
    if (cut.length) { tick(); setInterval(tick, 30000); }
  }

  function init() {
    window.PC = PC;
    initAnnc(); initHeader(); initTiles(); initReveal(); initSticky(); initDates();
    $$('[data-pc-buybox]').forEach(initBuyBox);
    $$('[data-pc-kit]').forEach(function (k) { if (!k.hasAttribute('data-pc-vest')) initKit(k); });
    $$('[data-pc-vest]').forEach(initVest);
    $$('[data-pc-finder]').forEach(initFinder);
    initLoops();
    getCart().catch(function () {});
    if (location.hash === '#cart') openDrawer('cart');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { $$('[data-pc-buybox]').forEach(initBuyBox); $$('[data-pc-kit]').forEach(function (k) { if (!k.hasAttribute('data-pc-vest')) initKit(k); }); $$('[data-pc-vest]').forEach(initVest); $$('[data-pc-finder]').forEach(initFinder); initReveal(); initLoops(); });
})();

/* product card photo swipe dots (touch) */
(function () {
  document.querySelectorAll('[data-pc-cm]').forEach(function (cm) {
    var t = cm.querySelector('.pc-cm__track'), d = cm.querySelectorAll('.pc-cm__dots i');
    if (!t || d.length < 2) return;
    t.addEventListener('scroll', function () { var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth)); d.forEach(function (x, k) { x.classList.toggle('is-on', k === i); }); }, { passive: true });
  });
})();

/* Desktop: show the buy-box Q&A rows under the product photos (left column), back in the buy box on phones */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  function place() {
    document.querySelectorAll('.pc-bb__grid').forEach(function (g) {
      var media = g.querySelector('.pc-bb__media'), info = g.querySelector('.pc-bb__info');
      if (!media || !info) return;
      var items = g.querySelectorAll('.pc-acc, .pc-bb__help');
      if (!items.length) return;
      items.forEach(function (el) {
        if (!el._pcHome) { el._pcHome = document.createComment('pc-acc-home'); el.parentNode.insertBefore(el._pcHome, el); }
        if (mq.matches) { if (el.parentNode !== media) media.appendChild(el); }
        else if (el.parentNode !== el._pcHome.parentNode) el._pcHome.parentNode.insertBefore(el, el._pcHome);
      });
      media.classList.toggle('has-acc', mq.matches);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
})();

/* No orphan words on mobile (Jay rule): glue the last two words of short text blocks with a non-breaking space */
(function () {
  var SEL = '.pc p,.pc li,.pc blockquote,.pc figcaption,.pc .jdgm-rev__body p';
  function glue(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.hasAttribute('data-pc-nbsp')) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
      while ((n = w.nextNode())) { if (n.nodeValue.trim()) last = n; }
      if (!last) return;
      var t = last.nodeValue, m = t.match(/^([\s\S]*?)(\S+)\s+(\S+)(\s*)$/);
      if (!m || m[2].length + m[3].length > 28) return;
      last.nodeValue = m[1] + m[2] + '\u00a0' + m[3] + m[4];
      el.setAttribute('data-pc-nbsp', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { glue(); }); else glue();
  window.addEventListener('load', function () { glue(); setTimeout(glue, 2500); });
  new MutationObserver(function () { clearTimeout(window.__pcg); window.__pcg = setTimeout(glue, 300); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { glue(e.target); });
})();


/* Oct 17 b: phone comment wall shows the first 8 cards, then a "See all" button (nothing removed) */
(function () {
  function init() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.pc-fbw').forEach(function (w) {
      var n = w.children.length; if (n <= 8 || w.classList.contains('is-short') || w.nextElementSibling && w.nextElementSibling.classList.contains('pc-fbw__all')) return;
      var c = w.querySelectorAll('.pc-fbw__c').length;
      w.classList.add('is-short');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pc-fbw__all';
      b.textContent = 'See all ' + c + ' owner comments';
      b.addEventListener('click', function () { w.classList.remove('is-short'); b.remove(); });
      w.insertAdjacentElement('afterend', b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* Oct 17 c: back-to-top button + prev/next buttons under phone swipe rows */
(function () {
  function sc() { return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0; }
  function top() {
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    document.documentElement.scrollTop = 0; document.body.scrollTop = 0;
  }
  function initTop() {
    if (document.querySelector('.pc-totop')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'pc-totop'; b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>';
    b.addEventListener('click', top); document.body.appendChild(b);
    var sticky = document.querySelector('.pc-sticky');
    function upd() {
      b.classList.toggle('is-on', sc() > 900);
      document.body.classList.toggle('pc-has-sticky', !!(sticky && sticky.classList.contains('is-on') && window.innerWidth < 990));
    }
    window.addEventListener('scroll', upd, { passive: true }); document.addEventListener('scroll', upd, { passive: true, capture: true }); upd();
  }
  var ROWS = '.pc-rs__list,.pc-ld__steps,.pc-why__pts,.pc-steps__list,.pc-guarantee__steps,.pc-ph__stats,.pc-xsw__grid';
  function initRows() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll(ROWS).forEach(function (row) {
      if (row.nextElementSibling && row.nextElementSibling.classList.contains('pc-rownav')) return;
      if (row.scrollWidth <= row.clientWidth + 8) return;
      var nav = document.createElement('div'); nav.className = 'pc-rownav';
      nav.innerHTML = '<button type="button" aria-label="Previous">&#8249;</button><button type="button" aria-label="Next">&#8250;</button>';
      var p = nav.children[0], n = nav.children[1];
      function step(dir) { var c = row.children[0]; row.scrollBy({ left: dir * ((c ? c.getBoundingClientRect().width : 280) + 12), behavior: 'smooth' }); }
      function state() { p.disabled = row.scrollLeft < 8; n.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8; }
      p.addEventListener('click', function () { step(-1); }); n.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', state, { passive: true }); state();
      row.insertAdjacentElement('afterend', nav);
    });
  }
  function init() { initTop(); initRows(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', initRows);
})();
/* Oct 17 d: body map, after a tap the matching product card is brought into view if it is hidden */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-pc-bm-go]'); if (!b) return;
  setTimeout(function () {
    var root = b.closest('[data-pc-bm]'); if (!root) return;
    var card = root.querySelector('.pc-bm__panel.is-on .pc-bm__prod'); if (!card) return;
    var r = card.getBoundingClientRect(), bottomSafe = window.innerHeight - (document.body.classList.contains('pc-has-sticky') ? 150 : 24);
    if (r.bottom > bottomSafe || r.top < 60) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 60);
});
/* Oct 17 e: phone "Your pick" card above the add-to-cart button, follows every size / kit tap */
(function () {
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function build(bb) {
    var atc = bb.querySelector('[data-pc-atc]'); if (!atc) return null;
    var c = bb.querySelector('.pc-pick'); if (c) return c;
    c = document.createElement('div'); c.className = 'pc-pick'; c.setAttribute('aria-live', 'polite');
    c.innerHTML = '<div class="pc-pick__img"><img alt="" loading="lazy"></div><div><p class="pc-pick__k">Your pick</p><p class="pc-pick__t"></p><p class="pc-pick__d"></p></div>';
    atc.insertAdjacentElement('beforebegin', c); return c;
  }
  function update(bb) {
    if (window.innerWidth > 749) return;
    var c = build(bb); if (!c) return;
    var card = bb.querySelector('.pc-offer.is-on');
    var img = card && (card.getAttribute('data-pc-kitimg') || (card.querySelector('img') && (card.querySelector('img').currentSrc || card.querySelector('img').src)));
    if (!img) { var g = bb.querySelector('.pc-gal img'); img = g && (g.currentSrc || g.src); }
    var im = c.querySelector('img'); if (img && im.getAttribute('src') !== img) im.src = img;
    var t = card && card.querySelector('.pc-offer__t') ? txt(card.querySelector('.pc-offer__t').firstChild) || txt(card.querySelector('.pc-offer__t')) : txt(bb.querySelector('.pc-kit__h'));
    c.querySelector('.pc-pick__t').textContent = t;
    var size = txt(bb.querySelector('[data-pc-sizename]')), price = txt(bb.querySelector('[data-pc-atc-price]'));
    c.querySelector('.pc-pick__d').textContent = [size ? 'Size: ' + size : '', price].filter(Boolean).join(' | ');
  }
  function all() { document.querySelectorAll('.pc-kit').forEach(update); }
  document.addEventListener('click', function (e) {
    var bb = e.target.closest && e.target.closest('.pc-kit'); if (!bb) return;
    setTimeout(function () { update(bb); }, 80);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(all, 300); }); else setTimeout(all, 300);
  window.addEventListener('load', all);
})();

/* Oct 17 g: no word is ever cut in half (hyphenated words stay whole, long headings shrink to fit).
   Line balance is done in CSS (text-wrap: balance on headings, pretty on paragraphs), no hard spaces between words. */
(function () {
  var SEL = '.pc h1,.pc h2,.pc h3,.pc h4,.pc h5,.pc p,.pc li,.pc blockquote,.pc figcaption,.pc summary,.pc .pc-btn,.pc .pc-offer__t,.pc .pc-offer__d,.pc .pc-steps__t,.pc .pc-steps__d,.pc .pc-ovl__txt,.pc .pc-acc__t,.pc .pc-menu-card__txt,.pc .jdgm-rev__title,.pc .jdgm-rev__body p';
  var HEADS = '.pc h1,.pc h2,.pc h3,.pc .pc-disp,.pc .pc-h2,.pc .pc-kit__h,.pc .pc-rs__t,.pc .pc-bm__t';
  /* a heading never ends with one word alone: short headings (4 words or fewer) stay on one line and shrink a little,
     longer ones keep their last two words together */
  function lastWordAlone(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
    while ((n = w.nextNode())) { if (n.nodeValue.trim()) last = n; }
    if (!last) return null;
    var v = last.nodeValue, end = v.replace(/\s+$/, '').length, start = v.slice(0, end).search(/\S+$/);
    if (start < 0) return null;
    var r = document.createRange(); r.setStart(last, start); r.setEnd(last, end);
    var a = r.getClientRects(); if (!a.length) return null;
    var top = a[0].top, er = el.getBoundingClientRect(), lh = parseFloat(getComputedStyle(el).lineHeight) || 30;
    var before = document.createRange(); before.setStart(el, 0); before.setEnd(last, start);
    var rs = before.getClientRects(), prevTop = rs.length ? rs[rs.length - 1].top : top;
    return { node: last, start: start, alone: top - prevTop > lh * 0.5 && top - er.top > lh * 0.5 };
  }
  function noLoneWord() {
    document.querySelectorAll(HEADS).forEach(function (el) {
      if (!el.offsetParent || el.hasAttribute('data-pc-lw')) return;
      var info = lastWordAlone(el); if (!info || !info.alone) return;
      var words = el.textContent.trim().split(/\s+/).length;
      el.setAttribute('data-pc-lw', '');
      if (words <= 4) { el.style.whiteSpace = 'nowrap'; return; }
      var v = info.node.nodeValue, i = v.slice(0, info.start).search(/ +$/);
      if (i >= 0) info.node.nodeValue = v.slice(0, i) + '\u00a0' + v.slice(info.start);
    });
  }
  function fit() {
    noLoneWord();
    document.querySelectorAll(HEADS).forEach(function (el) {
      if (!el.offsetParent) return;
      el.style.fontSize = '';
      var base = parseFloat(getComputedStyle(el).fontSize), fs = base, guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && fs > base * 0.6 && guard++ < 40) { fs -= base * 0.03; el.style.fontSize = fs + 'px'; }
      /* a one-line heading that would need to shrink too much goes back to normal wrapping */
      if (el.style.whiteSpace === 'nowrap' && (el.scrollWidth > el.clientWidth + 1 || fs < base * (el.textContent.trim().split(/\s+/).length <= 3 ? 0.62 : 0.8))) { el.style.whiteSpace = ''; el.style.fontSize = ''; }
    });
  }
  /* hyphenated words (lie-down, Full-Body, get-ups) never break at the hyphen */
  var HY = /[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+[,.;:!?)]*/g;
  function hyphens(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.hasAttribute('data-pc-hy')) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, list = [];
      while ((n = w.nextNode())) { if (!n.nodeValue.trim()) continue; if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('pc-nw')) continue; if (/[A-Za-z0-9]-[A-Za-z0-9]/.test(n.nodeValue)) list.push(n); }
      list.forEach(function (t) {
        var v = t.nodeValue; HY.lastIndex = 0; if (!HY.test(v)) return; HY.lastIndex = 0;
        var frag = document.createDocumentFragment(), last = 0, m;
        while ((m = HY.exec(v))) {
          if (m.index > last) frag.appendChild(document.createTextNode(v.slice(last, m.index)));
          var sp = document.createElement('span'); sp.className = 'pc-nw'; sp.style.whiteSpace = 'nowrap'; sp.textContent = m[0]; frag.appendChild(sp);
          last = m.index + m[0].length;
        }
        if (last < v.length) frag.appendChild(document.createTextNode(v.slice(last)));
        /* flex/grid parents turn each child into its own item, so keep the pieces in one inline wrapper */
        var pd = getComputedStyle(t.parentNode).display;
        if (/flex|grid/.test(pd)) { var wr = document.createElement('span'); wr.appendChild(frag); frag = wr; }
        t.parentNode.replaceChild(frag, t);
      });
      el.setAttribute('data-pc-hy', '');
    });
  }
  var tmr; function refit() { clearTimeout(tmr); tmr = setTimeout(fit, 120); }
  /* titles followed by a badge (Full Comfort Kit + Save $50): keep the last two words of the title text together */
  function titleGlue(root) {
    (root || document).querySelectorAll('.pc .pc-offer__t, .pc .pc-xs__t').forEach(function (el) {
      var t = el.firstChild; if (!t || t.nodeType !== 3) return;
      var m = t.nodeValue.match(/^([\s\S]*?)(\S+) (\S+)(\s*)$/); if (m && m[2].length + m[3].length <= 24) t.nodeValue = m[1] + m[2] + '\u00a0' + m[3] + m[4];
    });
  }
  function all(root) { hyphens(root); titleGlue(root); }
  function init() { all(); fit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { all(); fit(); setTimeout(function () { all(); fit(); }, 2500); });
  /* late content (FAQ, reviews app) gets the same treatment */
  var mo = new MutationObserver(function (ms) { var t; ms.forEach(function (m) { if (m.addedNodes.length) t = 1; }); if (t) { clearTimeout(mo._t); mo._t = setTimeout(function () { all(); fit(); }, 300); } });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', refit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  document.addEventListener('shopify:section:load', function (e) { all(e.target); fit(); });
  window.pcTextFix = function () { all(); fit(); };
})();


/* Nov 3 2026: red "See more" quote link removed, the "See more details" link to the product page is the only one */


/* Oct 22 2026: show the saving at checkout. Every add to cart gets two notes
   ("Regular price" and "You save") from the compare-at price; Shopify prints them
   under the item in the cart, at checkout and in the order emails. */
(function () {
  if (!window.fetch || window.__pcSaveNotes) return;
  window.__pcSaveNotes = true;
  var nativeFetch = window.fetch.bind(window);
  var prices = null;

  function usd(c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }

  // Variant price + compare-at, read from each product's JSON (cached for the session)
  function loadPrices() {
    if (prices) return prices;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('pc_vprices') || 'null'); } catch (e) {}
    if (cached) return (prices = Promise.resolve(cached));
    var cat = (window.PC && PC.cart && PC.cart.catalog) || {};
    var urls = Object.keys(cat).map(function (k) { return cat[k] && cat[k].url; }).filter(Boolean);
    prices = Promise.all(urls.map(function (u) {
      return nativeFetch(u.split('?')[0] + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var map = {};
      list.forEach(function (p) {
        (p && p.variants || []).forEach(function (v) { map[v.id] = [v.price, v.compare_at_price || 0]; });
      });
      try { sessionStorage.setItem('pc_vprices', JSON.stringify(map)); } catch (e) {}
      return map;
    });
    return prices;
  }

  function addNotes(item, map) {
    var pv = map[item.id];
    var cmp = (window.PC && PC.cart && PC.cart.compare && PC.cart.compare[item.id]) || (pv && pv[1]) || 0;
    if (!pv || !(cmp > pv[0])) return item;
    var qty = item.quantity || 1, save = cmp - pv[0];
    var props = Object.assign({}, item.properties || {});
    props['Regular price'] = usd(cmp) + (qty > 1 ? ' each' : '');
    props['Sale saving'] = qty > 1 ? usd(save * qty) + ' (' + usd(save) + ' each)' : usd(save);
    return Object.assign({}, item, { properties: props });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (init && init.method && /post/i.test(init.method) && /\/cart\/add(\.js)?(\?|$)/.test(url) && typeof init.body === 'string') {
      var body;
      try { body = JSON.parse(init.body); } catch (e) { body = null; }
      if (body && (body.items || body.id)) {
        return loadPrices().then(function (map) {
          if (body.items) body.items = body.items.map(function (it) { return addNotes(it, map); });
          else body = addNotes(body, map);
          return nativeFetch(input, Object.assign({}, init, { body: JSON.stringify(body) }));
        }, function () { return nativeFetch(input, init); });
      }
    }
    return nativeFetch(input, init);
  };

  // Warm the price list so adding to cart stays instant
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadPrices);
  else loadPrices();
})();
